export const ArrowRightIcon = ({
  width = 24,
  height = 24,
  className,
  title = "Arrow Right",
  ...rest
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    {...rest}>
    <title>{title}</title>
    <path
      fill="currentColor"
      stroke="currentColor"
      d="M13.34 5.64a.5.5 0 0 1 .707.011l5.812 6a.5.5 0 0 1 0 .696l-5.812 6a.5.5 0 0 1-.719-.696L18.32 12.5H4.5a.5.5 0 0 1 0-1h13.818l-4.99-5.151a.5.5 0 0 1 .012-.707Z"
    />
  </svg>
);
